import { createFileRoute } from '@tanstack/react-router';
import { DocumentSharingPage } from '@/features/preparer/document-sharing/DocumentSharingPage';

export const Route = createFileRoute('/preparer/sent-documents/')({
  component: DocumentSharingPage,
});
